const TAG_NAME_FILE_TYPE_MAP = {
  'Autopsy Report': 'autopsy_report',
  'Family History': 'family_history',
  'Medical History': 'medical_history',
  Other: 'other',
  Pedigree: 'pedigree'
}

export default TAG_NAME_FILE_TYPE_MAP
